import { FC } from 'react';
import { CircularProgress } from '@mui/material';
import { SALE_ORDER_ITEM_TYPE } from '@bandido/shared/constants';
import { useParams } from 'react-router-dom';
import { ListLayout } from '../../common/components/ListLayout';
import { useSnackBar } from '../../common/components/SnackBarContext';
import { SaleOrderHotel } from './hotel';
import { RuteroSaleOrderItem } from '@frontend/features/travel-services/components/RuteroSaleOrderItem';
import { useGetSaleOrderDetailItem } from '../queries';
import { useTranslation } from 'react-i18next';

export const SaleOrderItem:FC = () => {
  const { itemId } = useParams();
  const { data: service, isLoading } = useGetSaleOrderDetailItem({ itemId });
  const { addToast } = useSnackBar();
  const { t } = useTranslation();

  const doRender = () => {
    if (isLoading) {
      return (<CircularProgress color="inherit" />);
    } else if (!service && itemId) {
      // El GET de item filtra type='hotel': un item de SERVICIOS (vertical de
      // Rutero) viene null — se resuelve por el booking vinculado.
      return <RuteroSaleOrderItem itemId={itemId} />;
    } else if (service?.type === SALE_ORDER_ITEM_TYPE.Hotel) {
      const [ booking ] = service.bookings || [];
      const [ quotation] = service.quotations || [];
      if (service.metadata && service.hotel) {
        return (
          <SaleOrderHotel
            hotel={{
              categoryId: service.hotel.categoryId,
              address: service.hotel.address,
              amenities: service.hotel.amenities,
              chainCode: service.hotel.chainCode,
              city: service.hotel.city,
              country: service.hotel.country,
              hotelCode: service.hotel.code,
              name: service.hotel.name,
              nimbuxHotelId: service.hotel.id,
              picture: service.hotel.medias.length ? service.hotel.medias[0].url : '',
              zipCode: service.hotel.zipCode,
              providerHotelName: service.hotel.providerHotelName,
            }}
            id = { service.id }
            metadata = { service.metadata }
            booking= { booking }
            quotation= { quotation }
          />
        );
      } else {
        addToast({
          color: 'error',
          message: t('common.error')
        });
      }
    }
  };

  return (
    <ListLayout
      padding={0}
      title={''}
      subtitle={''}
    >
      {doRender()}
    </ListLayout>
  );
};
